const kontakt = {
  title: "Kontakt",
  company: "OH, JA!",
  firstname: "Philipp",
  lastname: "von Mauch",
  address: {
    street: "Morassistraße 4",
    plz: "80469",
    location: "München",
    country: "Deutschland",
  },
  email: "hallo@oh-ja.com",
  // phone: "089 / 92 58 30 60",
  // mobile: "+49 170 112 1337",
  fax: "xxxx",
  // googlemaps: "https://goo.gl/maps/Dr2QracSwjBWjprb8",
  googlemaps: "https://maps.app.goo.gl/gSMPNLvF9rojKjH99",
  // googlemaps: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2662.837376857231!2d11.580264276772755!3d48.13265945150296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479ddf63d6dc11b5%3A0x1fc9a796cb1ba2b5!2sOH%2C%20JA*21!5e0!3m2!1sde!2sde!4v1778146476345!5m2!1sde!2sde",
  instagram: "https://www.instagram.com/oh___ja",
  behance: "https://www.behance.net/oh-ja",
};

export default kontakt;
